import { render, staticRenderFns } from "./role-management.pug?vue&type=template&id=4b54bf93&lang=pug&"
import script from "./role-management.ts?vue&type=script&lang=ts&"
export * from "./role-management.ts?vue&type=script&lang=ts&"
import style0 from "./role-management.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports